import FormInput from "../UI/FormInput";
import { useTranslation } from "react-i18next";

const CampusAttributeNameInDirectoryInput = () => {
  const { t } = useTranslation("form");
  return ((
  <FormInput
    label={t("campusAttributeNameDirectory")}
    placeholder={t("campusAttributeNameDirectory")}
    id="attribute_name_in_directory"
    type="text"
    autoComplete="campus attribute name in directory"
    required={false}
    helperText={t("nameCampusActiveDirectoryOther")}
  />
));
};
export default CampusAttributeNameInDirectoryInput;